module.exports = __WEBPACK_EXTERNAL_MODULE_coveo_search_ui__;